<ng-container *ngIf="isActive && state">
  <!-- Overlay tło -->
  <div class="tour-overlay" [class.tour-overlay-dimmed]="!highlightStyle || isTransitioning" (click)="onBackdropClick($event)">
    <!-- Podświetlony element (dziura w overlay) -->
    <div
      class="tour-highlight"
      [class.tour-hidden]="isTransitioning"
      [class.tour-sliding]="isSliding"
      *ngIf="highlightStyle"
      [ngStyle]="highlightStyle">
    </div>
  </div>

  <!-- Komunikat po kliknięciu w tło -->
  <div class="tour-backdrop-message" *ngIf="showBackdropMessage">
    <mat-icon [svgIcon]="'tabler_outline:info-circle'" class="!w-4 !h-4"></mat-icon>
    Jesteś w trybie przewodnika — pomiń go lub przejdź do końca.
  </div>

  <!-- Tooltip -->
  <div #tooltipEl class="tour-tooltip"
    [class.tour-tooltip-centered]="!highlightStyle && !isTransitioning"
    [class.tour-hidden]="isTransitioning"
    [class.tour-sliding]="isSliding">
    <div class="tour-tooltip-counter" *ngIf="!isHelpStep && !isRatingStep">{{ stepCounter }}</div>
    <h3 class="tour-tooltip-title">{{ step?.title }}</h3>
    <p class="tour-tooltip-desc">{{ step?.description }}</p>

    <div class="tour-tooltip-actions">
      <!-- Krok pomocy (po pominięciu) -->
      <ng-container *ngIf="isHelpStep">
        <div class="tour-nav-buttons" style="width: 100%; justify-content: flex-end;">
          <button mat-flat-button color="primary" (click)="finishTour()">
            Rozumiem
            <mat-icon class="!w-4 !h-4 !ml-1" [svgIcon]="'tabler_outline:check'"></mat-icon>
          </button>
        </div>
      </ng-container>

      <!-- Standardowe kroki (nie-rating, nie-help) -->
      <ng-container *ngIf="!isRatingStep && !isHelpStep">
        <button mat-button (click)="skip()" class="tour-skip-btn" *ngIf="!isPreRatingStep">
          Pomiń przewodnik
        </button>
        <div class="tour-nav-buttons" [style.width]="isPreRatingStep ? '100%' : 'auto'" [style.justify-content]="isPreRatingStep ? 'flex-end' : ''">
          <button mat-stroked-button color="primary" (click)="prev()" *ngIf="!isFirstStep && !isPreRatingStep">
            Wstecz
          </button>
          <button mat-flat-button color="primary" (click)="next()">
            {{ actionText }}
            <mat-icon class="!w-4 !h-4 !ml-1" [svgIcon]="'tabler_outline:arrow-right'"></mat-icon>
          </button>
        </div>
      </ng-container>

      <!-- Krok oceny -->
      <ng-container *ngIf="isRatingStep">
        <div class="tour-rating-wrapper" style="width: 100%">
          <div class="tour-rating">
            <!-- Emoji + ocena -->
            <div class="tour-rating-feedback">
              <span class="tour-rating-emoji" [class.tour-rating-emoji-inactive]="!selectedRating && !hoverRating">{{ getRatingEmoji(hoverRating || selectedRating || 0) }}</span>
              <span class="tour-rating-value" *ngIf="selectedRating || hoverRating">{{ hoverRating || selectedRating }}/5</span>
              <span class="tour-rating-value tour-rating-value-placeholder" *ngIf="!selectedRating && !hoverRating">&nbsp;</span>
            </div>

            <div class="tour-stars tour-stars-lg">
              <mat-icon *ngFor="let star of [1,2,3,4,5]"
                class="tour-star tour-star-lg"
                [class.tour-star-active]="star <= (hoverRating || selectedRating)"
                (mouseenter)="hoverRating = star"
                (mouseleave)="hoverRating = 0"
                (click)="setRating(star)"
                [svgIcon]="star <= (hoverRating || selectedRating) ? 'tabler_solid:star' : 'tabler_outline:star'">
              </mat-icon>
            </div>
          </div>

          <button mat-flat-button color="primary" class="!w-full" (click)="finishTour()" [disabled]="!selectedRating">
            <span>Zakończ przewodnik</span>
            <mat-icon class="!w-4 !h-4 !ml-2" [svgIcon]="'tabler_outline:check'"></mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
